import styled, { css } from 'styled-components'
import { width, WidthProps } from 'styled-system'

export type ContainerProps = WidthProps & { isClickable?: boolean }

const isClickableCss = ({ isClickable }: ContainerProps) =>
  isClickable &&
  css`
    cursor: pointer;
  `

const shouldForwardProp = (prop: string) => !['isClickable'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;

  ${isClickableCss}

  ${width}
`
